import React from "react";

const GoogleWorkspaceAccess = () => {
  return (
    <div className="bg-gradient-to-b from-[#F5F7FA] to-white">
      <div className="border-t border-b">
        <div className="relative max-w-[1200px] mx-auto px-4 pt-20 pb-10 border-r border-l">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full">
            <div className="relative">
              <img
                src="/path-to-dots-image.png"
                alt=""
                className="w-full"
                aria-hidden="true"
              />
            </div>
          </div>

          <div className="relative z-10">
            <h2 className="text-center text-4xl font-semibold text-[#212F40] mb-2">
              Access all your marketing data
            </h2>
            <h2 className="text-center text-4xl font-semibold text-gray-800 mb-6">
              without leaving
            </h2>

            <div className="text-center text-2xl lg:text-3xl font-semibold mb-16 flex items-center justify-center gap-2">
              <span className="flex items-center">
                <span className="text-[#4285F4] text-3xl lg:text-5xl">G</span>
                <span className="text-[#EA4335] text-3xl lg:text-5xl">o</span>
                <span className="text-[#FBBC05] text-3xl lg:text-5xl">o</span>
                <span className="text-[#4285F4] text-3xl lg:text-5xl">g</span>
                <span className="text-[#34A853] text-3xl lg:text-5xl">l</span>
                <span className="text-[#EA4335] text-3xl lg:text-5xl">e</span>
              </span>
              <span className="text-[#5F6368] text-3xl lg:text-5xl">Workspace</span>
            </div>

            <div className="relative bottom-20">
              <img
                src="/workspace/pattern.svg"
                alt="Google Workspace files with graphs and data"
                className="w-full"
              />
              <img
                src="/workspace/files.svg"
                alt="Google Workspace files with graphs and data"
                className="w-full rounded-lg"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="border-b">
        <div className=" relative flex border-r border-l max-w-[1200px] mx-auto  py-5">
          <div className="flex mx-auto items-center space-x-5">
            <div className="text-xl geist-mono">
              <span className="text-[#697586]">Looking for </span>
              <span className="text-[#212f40]">DataStudio</span>
              <span className="text-[#697586]">?</span>
            </div>
            <button className="text-[#212f40] font-semibold border rounded-xl px-5 py-4 hover:bg-gray-200 transition-transform duration-300 ">
              Check it out
            </button>
          </div>
          <div className="absolute left-1 -translate-x-1/2 -top-2 w-4 h-4 rounded-full border border-[#cfd5de] bg-white"></div>

          <div className="absolute -top-px -right-px w-4 h-4 border-t-2 border-r-2 border-black"></div>

          <div className="absolute -bottom-px -left-px w-4 h-4 border-b-2 border-l-2 border-black"></div>
          <div className="absolute right-1 -translate-x-1 -bottom-2 w-4 h-4 rounded-full border border-[#cfd5de] bg-white"></div>
        </div>
      </div>
    </div>
  );
};

export default GoogleWorkspaceAccess;
